import { useMemo } from 'react';
import i18n from 'i18next';
import { Step, Steps } from './types';
import { useConfig } from '../../context';
import { StepsEnum } from '../../types';

export const useAvailableSteps = (steps: Steps, activeStep?: Step) => {
	const config = useConfig().global;

	const defaultSteps = useMemo(() => {
		return {
			[StepsEnum.Flights]: {
				label: i18n.t('Stepbar:Flights')
			},
			[StepsEnum.Passengers]: {
				label: i18n.t('Stepbar:Passengers')
			},
			[StepsEnum.Order]: {
				label: i18n.t('Stepbar:Order')
			},
			[StepsEnum.Payment]: {
				label: i18n.t('Stepbar:Payment')
			}
		} as Steps;
	}, [i18n.language]);

	const availableSteps = useMemo(() => {
		const actualSteps = steps ? { ...steps } : defaultSteps;

		if (config.stepsAvailable?.[StepsEnum.Meal] === false) {
			delete actualSteps.Meal;
		}

		return actualSteps;
	}, [defaultSteps, steps, config.stepsAvailable]);

	const currentAvailableStepIndex = useMemo(() => {
		const index = Object.values(availableSteps).findIndex(step => step.type === activeStep?.type);

		return index === -1 ? 0 : index;
	}, [availableSteps, activeStep?.type]);

	return {
		availableSteps,
		currentAvailableStepIndex
	};
};
